import { render, staticRenderFns } from "./SettlementOptionTasks.vue?vue&type=template&id=23cc732d&"
import script from "./SettlementOptionTasks.vue?vue&type=script&lang=js&"
export * from "./SettlementOptionTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports